import { render } from "./TestimonialsView.vue?vue&type=template&id=7893ffcc&scoped=true"
const script = {}

import "./TestimonialsView.vue?vue&type=style&index=0&id=7893ffcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7893ffcc"]])

export default __exports__